const {setDefaultSubproduct, updateBookingAction} = require('../subproducts-list/subproducts-selection');

document.addEventListener('DOMContentLoaded', function () {
    if ($('#calendarComponent').length === 0) {
        return;
    }

    function createLocalDate(dateStr) {
        if (!dateStr) return new Date();
        const parts = dateStr.split('-');

        return new Date(parts[0], parts[1] - 1, parts[2] || 1);
    }

    let preferredStartDate = null;
    if (localStorage.getItem('preferredDate')) {
        const prefferedTimestamp = JSON.parse(localStorage.getItem('preferredDate'));
        const now = new Date().getTime();

        if (prefferedTimestamp.expiry > now) {
            const prefferedDate = new Date(prefferedTimestamp.value * 1000);
            if (prefferedDate instanceof Date) {
                preferredStartDate = prefferedDate;
            }
        }
        localStorage.removeItem('preferredDate');
    }

    const calendarBody = document.getElementById('calendarBody');
    const currentMonthElement = document.getElementById('currentMonth');
    const prevMonthButton = document.getElementById('prevMonth');
    const nextMonthButton = document.getElementById('nextMonth');
    const inputCalendarIcon = document.getElementById('inputCalendarIcon');

    const dateAttr = currentMonthElement.getAttribute('data-start-date');
    const customStartDate = preferredStartDate ?? (dateAttr ? createLocalDate(dateAttr) : new Date());

    let startDate = customStartDate ?? new Date();
    let startDateString = startDate.toISOString().split('T')[0];
    let currentDay = startDate.getDate();
    let currentMonth = startDate.getMonth();
    let currentYear = startDate.getFullYear();
    let currentAbortController = null;

    $(prevMonthButton).on('click tap', function () {
        updateMonth(-1);
    });

    $(nextMonthButton).on('click tap', function () {
        updateMonth(1);
    });

    $(inputCalendarIcon).on('click tap', function () {
        $('html, body').animate({
            scrollTop: $('.calendar').offset().top - 100
        }, 590);
    });

    $('#private_or_group').on('change', function () {
        let currentSelectedDate = $('#serviceOrderForm #tour_date').val();
        renderCalendar(currentSelectedDate);
    });

    $('#tour_lang').on('change', function () {
        renderCalendar($('#serviceOrderForm #tour_date').val());
    });

    renderCalendar(startDateString);


    function updateMonth(change, isInitial = false) {
        currentDay = false;
        currentMonth += change;
        if (currentMonth < 0) {
            currentMonth = 11;
            currentYear--;
        } else if (currentMonth > 11) {
            currentMonth = 0;
            currentYear++;
        }
        currentMonthElement.textContent = `${getMonthName(currentMonth)} ${currentYear}`;
        renderCalendar();
    }

    function renderCalendar(currentSelectedDate = null) {
        $('.calendar__body').addClass('d-none');
        $('.calendar__loader').removeClass('d-none');
        $('.subproductsListComponent .preloadMask').show();
        updateBookingAction();

        let daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        let firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();

        if (currentAbortController) {
            currentAbortController.abort();
        }

        currentAbortController = new AbortController();
        const {signal} = currentAbortController;

        getUpcomingAvailabilities(signal).then(function (availabilities) {
            const privateDates = availabilities.private || [];
            const groupDates = availabilities.group || [];
            let privacyType = $('#private_or_group').val()
            if(!privacyType || privacyType === 'undefined') {
                privacyType = 'Group';
            }

            if (groupDates.length > 0 && privacyType === 'Group') {
                let firstGroupDate = createLocalDate(groupDates[0]);
                currentMonth = firstGroupDate.getMonth();
                currentYear = firstGroupDate.getFullYear();
                daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
                firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
            }

            if (privateDates.length > 0 && privacyType === 'Private') {
                let firstPrivateDate = createLocalDate(privateDates[0]);
                currentMonth = firstPrivateDate.getMonth();
                currentYear = firstPrivateDate.getFullYear();
                daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
                firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
            }

            calendarBody.innerHTML = '';

            for (let i = 0; i < firstDayOfMonth; i++) {
                const emptyDay = createCalendarDay('');
                calendarBody.appendChild(emptyDay);
            }

            const dayToSelect = getFirstAvailableDay(availabilities, currentSelectedDate);
            if (!dayToSelect) {
                $('#serviceOrderForm #tour_date').val('');
                setDefaultSubproduct();
                $('.subproductsListComponent .preloadMask').hide();
            }
            for (let i = 1; i <= daysInMonth; i++) {
                const day = createCalendarDay(i);
                const dateString = `${currentYear}-${padNumber(currentMonth + 1)}-${padNumber(i)}`;
                handleAvailableDay(day, dateString, privateDates, groupDates, dayToSelect);
                calendarBody.appendChild(day);
            }

            currentMonthElement.textContent = `${getMonthName(currentMonth)} ${currentYear}`;

            $('.calendar__body').removeClass('d-none');
            $('.calendar__loader').addClass('d-none');

            $('.calendar').data('currentMonth', currentMonth).data('currentYear', currentYear);

            let calendarRenderedEvent = new Event('calendarRendered');
            document.dispatchEvent(calendarRenderedEvent);
            updateBookingAction();
        }).catch(function (error) {
            if (error.name === 'AbortError') {
                return;
            } else {
                console.error('There was a problem with fetching availabilities:', error);
            }
            window.availabilityDay = {Group: [], Private: []};
            window.availabilityRawData = {};
            window.subproductAvailableDates = null;
            $('#serviceOrderForm #tour_date').val('');
            setDefaultSubproduct();
            $('.calendar__loader').addClass('d-none');
            $('.subproductsListComponent .preloadMask').hide();
            updateBookingAction();
        });
    }

    function createCalendarDay(dayNumber) {
        const day = document.createElement('div');
        day.setAttribute('data-day-number', dayNumber);
        day.innerHTML = '<div class="calendar-day-header">' + dayNumber + '</div>';
        day.classList.add('calendar__day', 'calendar__day--disabled');
        return day;
    }

    function handleAvailableDay(day, dateString, privateDates, groupDates, firstAvailableDay) {
        const currentPrivacyType = getCurrentPrivacyType();
        let additionalInfo = '';
        if (currentPrivacyType === 'Group' && !groupDates.includes(dateString) && privateDates.includes(dateString)) {
            additionalInfo = '<div class="calendar__day--privacyBadge">Private<br/>only</div>';
        } else if (currentPrivacyType === 'Private' && !privateDates.includes(dateString) && groupDates.includes(dateString)) {
            additionalInfo = '<div class="calendar__day--privacyBadge">Shared<br/>only</div>';
        }

        if (additionalInfo) {
            day.addEventListener('click', () => {
                $('#serviceOrderForm #tour_date').val(dateString);
                $('#private_or_group').val(currentPrivacyType === 'Group' ? 'Private' : 'Group').change();
            });
            day.classList.add('calendar__day--warning');
            day.innerHTML += `${additionalInfo}`;
            return;
        }

        let priceBadge = '';
        priceBadge = '<div class="calendar__day--priceBadge"><span class="calendarPriceSpinner spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></div>';
        day.innerHTML += `${priceBadge}`;

        if ((currentPrivacyType === 'Group' && groupDates.includes(dateString)) || (currentPrivacyType === 'Private' && privateDates.includes(dateString))) {
            day.classList.remove('calendar__day--disabled');
            day.classList.add('calendar__day--enabled');
            day.addEventListener('click', () => {
                selectDay(day);
            });
        }

        if (privateDates.includes(dateString)) {
            day.classList.add('calendar__day--private');
        } else if (groupDates.includes(dateString)) {
            day.classList.add('calendar__day--group');
        }

        if (firstAvailableDay === dateString) {
            selectDay(day, false);
        }
    }

    function padNumber(number) {
        return number.toString().padStart(2, '0');
    }

    function selectDay(selectedDay, withScroll = true) {
        const days = document.querySelectorAll('.calendar__day');
        days.forEach(day => {
            day.classList.remove('calendar__day--selected');
        });
        selectedDay.classList.add('calendar__day--selected');
        $('#serviceOrderForm #tour_date').val(`${currentYear}-${padNumber(currentMonth + 1)}-${padNumber(selectedDay.getAttribute('data-day-number'))}`).change();

        if (withScroll) {
            let scrollDestinationElement = $('.servicePrivacySwitcher').length > 0 ? $('.servicePrivacySwitcher') : $('.subproductsListComponent');
            $('html, body').animate({
                scrollTop: scrollDestinationElement.offset().top - 100
            }, 1000);
        }
    }

    function getMonthName(monthIndex) {
        const lang = $('#lang_choice_2 option:selected').attr('lang');
        let monthNames = [];
        switch (lang) {
            case 'pl-PL':
                monthNames = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];
                break;
            case 'es-ES':
                monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
                break;
            case 'it-IT':
                monthNames = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
                break;
            case 'de-DE':
                monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
                break;
            case 'fr-FR':
                monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
                break;
            default:
                monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                break;
        }
        return monthNames[monthIndex];
    }

    function getUpcomingAvailabilities(signal, setStartDate = false) {
        let params = {
            action: 'get-upcoming-availabilities',
            service_id: currentServiceId,
            start_date: `${currentYear}-${padNumber(currentMonth + 1)}-01`,
            lang: $('#tour_lang').val() ?? 'ANG'
        };

        let currentUrl = new URL(window.location.href);
        let ajaxUrl = currentUrl.origin + '/wp-admin/admin-ajax.php';
        let url = new URL(ajaxUrl);
        url.search = new URLSearchParams(params).toString();

        return fetch(url, {signal})
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            }).then(function (availabilities) {
                window.availabilityRawData = availabilities.rawData || [];
                window.subproductAvailableDates = availabilities.subproductDates || null;
                window.availabilityDay = {
                    Group: availabilities.group || [],
                    Private: availabilities.private || []
                };
                return availabilities;
            });
    }

    function getCurrentPrivacyType() {
        return $('#serviceOrderForm #private_or_group').val();
    }

    function getCurrentSelectedDate() {
        return $('#serviceOrderForm #tour_date').val();
    }

    function getFirstAvailableDay(availabilities, currentSelectedDate) {
        let currentPrivacyType = getCurrentPrivacyType();
        if (currentPrivacyType === 'Group') {
            if (currentSelectedDate && (availabilities.group.includes(currentSelectedDate))) {
                return currentSelectedDate;
            }

            return availabilities.group[0];
        }

        if (currentPrivacyType === 'Private') {
            if (currentSelectedDate && (availabilities.private.includes(currentSelectedDate))) {
                return currentSelectedDate;
            }
            return availabilities.private[0];
        }

        return null;
    }


});
